import img3 from "../Assets/img3.png";
import img4 from "../Assets/img4.jpg";
import img5 from "../Assets/img5.jpg";

export const SuggestionsData=[
    { name: "Sumit Sharma", username: "sumitsharma", img: img3 },
    { name: "Chhayank Singh", username: "singh_chhayank", img: img4 },
    { name: "Ayush Sharma", username: "Ayush_sharma", img: img5 },
]